import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { UsersManagement } from '../../components/admin/UsersManagement';

export function UsersPage() {
  return (
    <AdminLayout
      title="Utilisateurs"
      description="Gérez les utilisateurs de la plateforme"
    >
      <UsersManagement />
    </AdminLayout>
  );
}
